import { render } from "./StyledButton.vue?vue&type=template&id=a67e5656&scoped=true"
import script from "./StyledButton.vue?vue&type=script&lang=js"
export * from "./StyledButton.vue?vue&type=script&lang=js"

import "./StyledButton.vue?vue&type=style&index=0&id=a67e5656&scoped=true&lang=css"

import exportComponent from "/home/n3rdy/dev/virtuallab-networksecurity/exp-5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a67e5656"]])

export default __exports__